import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props { children: ReactNode }
interface State { error: Error | null }

/**
 * Letzte Absicherung: ein Renderfehler darf niemals als weisse Seite enden,
 * weil der Nutzer dann nicht einmal mehr an seine Sicherung kaeme.
 */
export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Unbehandelter Fehler in der Oberfläche:', error, info.componentStack);
  }

  override render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="mx-auto flex max-w-lg flex-col gap-4 px-6 py-16">
        <h1 className="text-lg font-semibold">Da ist etwas schiefgelaufen</h1>
        <p className="text-sm leading-relaxed text-ink-muted">
          Deine Daten sind nicht betroffen — sie liegen unverändert in diesem Browser.
          Lade die Seite neu. Falls der Fehler bleibt, öffne die Einstellungen und lade
          eine Sicherung herunter, bevor du weitermachst.
        </p>
        <pre className="overflow-x-auto rounded-md border border-line bg-surface-raised p-3 text-[12px] text-ink-muted">
          {this.state.error.message}
        </pre>
        <div>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="h-9 rounded-md bg-accent px-3.5 text-sm font-medium text-on-accent"
          >
            Neu laden
          </button>
        </div>
      </div>
    );
  }
}
